import * as Flux from 'dg-web-shared/lib/Flux.tsx';

export const flux = new Flux.Store();
